import { FieldViewModes } from "../../canvas/state/types";
import { LinkedRecordListMode } from "../../canvas/types";

export const standardOSFontsSet = new Set(
  [
    // Windows 10
    "Arial",
    "Arial Black",
    "Bahnschrift",
    "Calibri",
    "Cambria",
    "Cambria Math",
    "Candara",
    "Comic Sans MS",
    "Consolas",
    "Constantia",
    "Corbel",
    "Courier New",
    "Ebrima",
    "Franklin Gothic Medium",
    "Gabriola",
    "Gadugi",
    "Georgia",
    "HoloLens MDL2 Assets",
    "Impact",
    "Ink Free",
    "Javanese Text",
    "Leelawadee UI",
    "Lucida Console",
    "Lucida Sans Unicode",
    "Malgun Gothic",
    "Marlett",
    "Microsoft Himalaya",
    "Microsoft JhengHei",
    "Microsoft New Tai Lue",
    "Microsoft PhagsPa",
    "Microsoft Sans Serif",
    "Microsoft Tai Le",
    "Microsoft YaHei",
    "Microsoft Yi Baiti",
    "MingLiU-ExtB",
    "Mongolian Baiti",
    "MS Gothic",
    "MV Boli",
    "Myanmar Text",
    "Nirmala UI",
    "Palatino Linotype",
    "Segoe MDL2 Assets",
    "Segoe Print",
    "Segoe Script",
    "Segoe UI",
    "Segoe UI Historic",
    "Segoe UI Emoji",
    "Segoe UI Symbol",
    "SimSun",
    "Sitka",
    "Sylfaen",
    "Symbol",
    "Tahoma",
    "Times New Roman",
    "Trebuchet MS",
    "Verdana",
    "Webdings",
    "Wingdings",
    "Yu Gothic",
    // macOS
    "American Typewriter",
    "Andale Mono",
    "Arial",
    "Arial Black",
    "Arial Narrow",
    "Arial Rounded MT Bold",
    "Arial Unicode MS",
    "Avenir",
    "Avenir Next",
    "Avenir Next Condensed",
    "Baskerville",
    "Big Caslon",
    "Bodoni 72",
    "Bodoni 72 Oldstyle",
    "Bodoni 72 Smallcaps",
    "Bradley Hand",
    "Brush Script MT",
    "Chalkboard",
    "Chalkboard SE",
    "Chalkduster",
    "Charter",
    "Cochin",
    "Comic Sans MS",
    "Copperplate",
    "Courier",
    "Courier New",
    "Didot",
    "DIN Alternate",
    "DIN Condensed",
    "Futura",
    "Geneva",
    "Georgia",
    "Gill Sans",
    "Helvetica",
    "Helvetica Neue",
    "Herculanum",
    "Hoefler Text",
    "Impact",
    "Lucida Grande",
    "Luminari",
    "Marker Felt",
    "Menlo",
    "Microsoft Sans Serif",
    "Monaco",
    "Noteworthy",
    "Optima",
    "Palatino",
    "Papyrus",
    "Phosphate",
    "Rockwell",
    "Savoye LET",
    "SignPainter",
    "Skia",
    "Snell Roundhand",
    "Tahoma",
    "Times",
    "Times New Roman",
    "Trattatello",
    "Trebuchet MS",
    "Verdana",
    "Zapfino",
  ].sort(),
);

export const fontWeightOptions = [
  // {
  //   value: 100,
  //   label: "Thin",
  // },
  // {
  //   value: "extra-light",
  //   label: "Extra Light",
  // },
  // {
  //   value: "light",
  //   label: "Light",
  // },
  // {
  //   value: "medium",
  //   label: "Medium",
  // },
  // {
  //   value: "semi-bold",
  //   label: "Semi Bold",
  // },
  // {
  //   value: 700,
  //   label: "Extra bold",
  // },
  {
    value: "normal",
    label: "Normal",
  },
  {
    value: "bold",
    label: "Bold",
  },
];

export const LinkedRecordModeOptions = [
  {
    value: FieldViewModes.table,
    label: "Table",
  },
  {
    value: FieldViewModes.list,
    label: "List",
  },
  {
    value: FieldViewModes.single,
    label: "Single",
  },
];

export const LinkedRecordListModeOptions = [
  {
    value: LinkedRecordListMode.Bullets,
    label: "Bullets",
  },
  {
    value: LinkedRecordListMode.Numbers,
    label: "Numbers",
  },
  {
    value: LinkedRecordListMode.None,
    label: "None",
  },
];

export const MultipleSelectModeOptions = [
  {
    value: FieldViewModes.list,
    label: "List",
  },
  {
    value: FieldViewModes.single,
    label: "Single",
  },
];

export const lineHeightOptions = [
  {
    value: "1.2",
    label: "Tight",
  },
  {
    value: "1.4",
    label: "Normal",
  },
  {
    value: "1.6",
    label: "Wide",
  },
];
